<details>
  <summary>
    <i>01.</i>
    <span>How does MenoAge work?</span>
  </summary>
  <p>MenoAge works by focusing on glycan-based biomarkers. These change 7-10 years before menopause symptoms and diagnosis typically happen - meaning they’re able to predict future health problems. (They do this much more accurately than tests that focus solely on hormones.)</p>
  <p>Once you buy your kit, it’s shipped to your home with a return address. Our packaging is reliable and durable, meaning that if the post is delayed, it’s not a problem. It lasts for up to 2+ weeks.</p>
  <p>When you send your sample back, it’s analyzed in our lab. In 2-4 weeks you’ll receive your results in a personal, online dashboard. To help you fully understand your results, you’ll receive a consultation with a member of our specialist care team. They’ll help you contextualize the findings, and you can ask them any questions you might have.</p>
  <p>From there, you can share your results with your GP, who’ll prescribe medication if needed.</p>
</details>
<details>
  <summary>
    <i>02.</i>
    <span>What is menopause?</span>
  </summary>
  <p>Many of us associate menopause with hot flushes and night sweats. The truth is, this description only scratches the surface. During menopause, your body produces less estrogen and progesterone. This results in an increased risk of heart disease and osteoporosis, recurring UTI’s and many other illnesses and conditions. </p>
  <p>To manage symptoms and reduce risks, diet and lifestyle changes are sometimes required. In some cases, hormonal treatment helps too. </p>
  <p>Many women feel lonely during this stage of life, particularly because there’s still a social taboo surrounding menopause. This is starting to change and it’s something we want to accelerate. With this in mind, we’d love you to join the conversation on our social media and share your own experience.</p>
</details>
<details>
  <summary>
    <i>03.</i>
    <span>What is perimenopause?</span>
  </summary>
  <p>Alarmingly, recent research suggests that 50% of women have never heard of perimenopause. We want to tackle this, shining a light on cases where women are misdiagnosed, incorrectly prescribed antidepressants, and dismissed by the medical community at large.</p>
  <p>Perimenopause is the first phase of menopause, and can begin from the age of 35. Hormonal cycles change, causing symptoms including heart palpitations, mood changes, irregular periods, sleep problems, fluctuating cholesterol levels, and more.</p>
  <p>Because hormone tests are often used inappropriately, it currently takes women in the UK on average 6 to 7 years to get a correct diagnosis. 66% are misdiagnosed with fibromyalgia, migraines, depression, and even IBS. 71% have to take time off work in order to attend as many as 7 GP appointments, and 20% end up leaving their job due to the severity of symptoms.</p>
</details>
<details>
  <summary>
    <i>04.</i>
    <span>What is the science behind MenoAge?</span>
  </summary>
  <p>We conducted a study in collaboration with King’s College London, analysing a sample of 1,940 twins.  We found that the immune system ages much more rapidly during perimenopause, which is when oestradiol levels start to decline in women.</p>
  <p>In the past, clinicians have used hormone tests to identify menopause, but these have been deemed inappropriate by FDA and NICE because they’re susceptible to daily fluctuations. </p>
  <p>Our test isn’t affected in the same way as it relies on something called IgG glycans, which have a much longer half-life. Technically speaking, MenoAge is the first HbA1c-type predictive biomarker for perimenopause.</p>
  <p>The team here aims to help women around the world understand perimenopause and menopause. We want to make the surrounding care more objective, personalised, and cost effective, and we ultimately want women to have healthier lives for longer. </p>
</details>

<style>
  details {
    max-width: 90ch;
    margin-left: auto;
    margin-right: auto;
    margin: 3rem 0;
  }
  
  summary {
    display: flex;
    list-style: none;
    cursor: pointer;
  }
  
    summary:hover,
    summary:focus {
      color: var(--a1-b);
    }

  summary::-webkit-details-marker {
    display: none;
  }

  i {
    font-style: normal;
    font-size: calc(.75rem + 0.75vw);
    padding-top: 0.35rem;
    margin-right: 1rem;
  }
  
  span {
    text-decoration: underline;
    font-size: calc(1.75rem + 0.75vw);
  }

  p {
    font-size: 1.25rem;
    padding-left: 3rem;
    max-width: 70ch;
  }
</style>